import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OurTeamComponent } from 'src/app/home/components/our-team/our-team.component';
import { HomePageComponent } from '../components/home-page/home-page.component';

const routes: Routes = [
  { path: 'home', component: HomePageComponent },
  { path: 'Our-Team', component: OurTeamComponent, data: { breadcrumb: [{ labelKey: 'unifiedShell.pages.team' }] } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingRoutingModule { }
